import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
//Angular Material imports
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { DialogsModule } from "@cotecna/dialogs";
import { DynamicViewEngineModule } from "@cotecna/dynamic-view-engine";
import { FabSpeedDialModule } from "@cotecna/material";

import { FormDialogModule } from "../form-dialog/form-dialog.module";
import { ItemButtonComponent } from "./components/item-button/item-button.component";
import { ItemFormComponent } from "./components/item-form/item-form.component";
import { ItemListComponent } from "./components/item-list/item-list.component";
import { ItemSectionsComponent } from "./components/item-sections/item-sections.component";
import { ItemsContainerComponent } from "./components/items-container/items-container.component";
import { ItemsCreationComponent } from "./components/items-creation/items-creation.component";

@NgModule({
  declarations: [
    ItemsCreationComponent,
    ItemsContainerComponent,
    ItemSectionsComponent,
    ItemListComponent,
    ItemFormComponent,
    ItemButtonComponent,
  ],
  imports: [
    CommonModule,
    FabSpeedDialModule,
    FormDialogModule,
    DialogsModule,
    DynamicViewEngineModule,
    //Angular Material Imports
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatMenuModule,
  ],
  exports: [
    ItemsCreationComponent,
    ItemsContainerComponent,
    ItemListComponent,
    ItemFormComponent,
  ],
})
export class ItemsModule {}
